module.exports = __webpack_public_path__ + "static/media/bajopiso_vinilicos.e7cb1cca.jpg";